import React, { useState } from "react";
import { Table, Pagination, Button, Flex } from "antd";
import { FileExcelOutlined, FileTextOutlined } from "@ant-design/icons";
import { $t } from "~/i18n.js";
import { AdminFlightColumns } from "./AdminFlightColumns.jsx";
import { api } from "~/lib/api.js";

export function AdminFlightTable({
  flights,
  loading,
  onRowClick,
  pagination,
  currentPageNumber,
  setCurrentPage,
  getFlights,
  setFlights,
  onExportClick,
}) {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  const columns = AdminFlightColumns();

  const [loadSaveFlights, setLoadSaveFlights] = useState("");
  const saveFlightsIsDeleted = async (deleteOrRecover) => {
    setLoadSaveFlights(deleteOrRecover);

    let newFlights = flights;

    for (const uuid of selectedRowKeys) {
      const { data } = await api.post2("flights/save_flight.json", {
        action: deleteOrRecover,
        uuid,
        skip_currency: true,
      });
      if (data) {
        newFlights = newFlights.map((f) => {
          if (f.uuid == data.uuid) return data;
          return f;
        });
      }
    }
    setFlights(newFlights);
    setLoadSaveFlights("");
  };

  return (
    <>
      <Table
        rowSelection={rowSelection}
        loading={loading}
        style={{
          marginTop: 12,
          width: "95vw",
          overflowX: "auto",
          cursor: "pointer",
        }}
        pagination={false}
        size="small"
        rowKey="uuid"
        dataSource={flights}
        columns={columns}
        onRow={(flight) => {
          return {
            onClick: () => onRowClick(flight),
          };
        }}
      />

      <Pagination
        simple={true}
        onChange={(newPage) => {
          setCurrentPage(newPage);
          getFlights(newPage);
        }}
        showSizeChanger={false}
        pageSize={100}
        current={currentPageNumber}
        hideOnSinglePage={true}
        total={pagination["numberFlights"] || 0}
      />

      <Flex align="center" gap="middle" style={{ marginTop: 12 }}>
        <p>
          {$t("${n} geselecteerde vlucht(en)", { n: selectedRowKeys.length })}
        </p>

        <Button
          size="small"
          danger
          disabled={!hasSelected}
          loading={loadSaveFlights == "delete"}
          onClick={() => saveFlightsIsDeleted("delete")}
        >
          {$t("Verwijder")}
        </Button>

        <Button
          size="small"
          disabled={!hasSelected}
          loading={loadSaveFlights == "recover"}
          onClick={() => saveFlightsIsDeleted("recover")}
        >
          {$t("Herstel")}
        </Button>
      </Flex>

      <Flex align="center" gap="middle" style={{ marginTop: 12 }}>
        <p>{$t("Exporteer")}:</p>

        <Button
          icon={<FileTextOutlined />}
          size="small"
          onClick={() => onExportClick("csv")}
        >
          CSV
        </Button>

        <Button
          icon={<FileExcelOutlined />}
          size="small"
          onClick={() => onExportClick("xlsx")}
        >
          Excel
        </Button>
      </Flex>
    </>
  );
}
